import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "certificate-section" }
const _hoisted_2 = { class: "jumbotron jumbotron-fluid bg-2 m-0 pt-5 pb-5" }
const _hoisted_3 = { class: "container mt-5" }
const _hoisted_4 = {
  class: "row mt-4 justify-content-center",
  id: "resume_cer"
}
const _hoisted_5 = { class: "col-md-6 col-12 my-3 d-flex justify-content-center" }
const _hoisted_6 = { class: "blog-text p-3 text-center" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "col-md-6 col-12 my-3 d-flex justify-content-center" }
const _hoisted_10 = { class: "blog-text p-3 text-center" }
const _hoisted_11 = ["href"]
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  class: "row justify-content-center",
  id: "university_cer"
}
const _hoisted_14 = { class: "col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center" }
const _hoisted_15 = { class: "blog-text p-3 text-center" }
const _hoisted_16 = ["href"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center" }
const _hoisted_19 = { class: "blog-text p-3 text-center" }
const _hoisted_20 = ["href"]
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center" }
const _hoisted_23 = { class: "blog-text p-3 text-center" }
const _hoisted_24 = ["href"]
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center" }
const _hoisted_27 = { class: "blog-text p-3 text-center" }
const _hoisted_28 = ["href"]
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center" }
const _hoisted_31 = { class: "blog-text p-3 text-center" }
const _hoisted_32 = ["href"]
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center" }
const _hoisted_35 = { class: "blog-text p-3 text-center d-flex flex-column gap-3 justify-content-between h-100" }
const _hoisted_36 = ["href"]
const _hoisted_37 = ["src"]
const _hoisted_38 = ["href"]
const _hoisted_39 = ["src"]
const _hoisted_40 = {
  class: "row justify-content-center",
  id: "other_cer"
}
const _hoisted_41 = { class: "col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center" }
const _hoisted_42 = { class: "blog-text p-3 text-center" }
const _hoisted_43 = ["href"]
const _hoisted_44 = ["src"]
const _hoisted_45 = { class: "col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center" }
const _hoisted_46 = { class: "blog-text p-3 text-center" }
const _hoisted_47 = ["href"]
const _hoisted_48 = ["src"]
const _hoisted_49 = { class: "col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center" }
const _hoisted_50 = { class: "blog-text p-3 text-center" }
const _hoisted_51 = ["href"]
const _hoisted_52 = ["src"]
const _hoisted_53 = { class: "col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center" }
const _hoisted_54 = { class: "blog-text p-3 text-center" }
const _hoisted_55 = ["href"]
const _hoisted_56 = ["src"]
const _hoisted_57 = { class: "col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center" }
const _hoisted_58 = { class: "blog-text p-3 text-center" }
const _hoisted_59 = ["href"]
const _hoisted_60 = ["src"]
const _hoisted_61 = { class: "col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center" }
const _hoisted_62 = { class: "blog-text p-3 text-center" }
const _hoisted_63 = ["href"]
const _hoisted_64 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "row",
          id: "resume_cer_title"
        }, [
          _createElementVNode("div", { class: "col-12 text-center text-white" }, [
            _createElementVNode("h1", { class: "display-4 fw-bold" }, "Certificate"),
            _createElementVNode("hr", { class: "w-25 mx-auto border-3 opacity-75" })
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-md-12 text-center text-white" }, [
            _createElementVNode("h3", { class: "fw-semibold" }, "Resume")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "mb-3 text-dark" }, "Resume (Thai)", -1)),
              _createElementVNode("a", {
                href: `${_ctx.publicPath}images/cer/Resume_Kittichet_TH.pdf`,
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/images/cer/Resume_Kittichet_TH.jpg'),
                  class: "img-fluid img-thumbnail img-hover"
                }, null, 8, _hoisted_8)
              ], 8, _hoisted_7)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "mb-3 text-dark" }, "Resume (English)", -1)),
              _createElementVNode("a", {
                href: `${_ctx.publicPath}images/cer/Resume_Kittichet_EN.pdf`,
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/images/cer/Resume_Kittichet_EN.jpg'),
                  class: "img-fluid img-thumbnail img-hover"
                }, null, 8, _hoisted_12)
              ], 8, _hoisted_11)
            ])
          ])
        ]),
        _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"col-md-12 text-center my-4\" data-v-1b6af368><hr class=\"border-2 border-white opacity-50\" data-v-1b6af368></div><div class=\"row\" id=\"university_cer_title\" data-v-1b6af368><div class=\"col-md-12 text-center text-white mb-3\" data-v-1b6af368><h3 class=\"fw-semibold\" data-v-1b6af368>University</h3></div></div>", 2)),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("a", {
                href: require('@/assets/images/cer/gradeen.jpg'),
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/images/cer/gradeen.jpg'),
                  class: "img-fluid img-thumbnail img-hover"
                }, null, 8, _hoisted_17)
              ], 8, _hoisted_16)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("a", {
                href: require('@/assets/images/cer/gradeth.jpg'),
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/images/cer/gradeth.jpg'),
                  class: "img-fluid img-thumbnail img-hover"
                }, null, 8, _hoisted_21)
              ], 8, _hoisted_20)
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("a", {
                href: require('@/assets/images/cer/gradeth2.jpg'),
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/images/cer/gradeth2.jpg'),
                  class: "img-fluid img-thumbnail img-hover"
                }, null, 8, _hoisted_25)
              ], 8, _hoisted_24)
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("a", {
                href: require('@/assets/images/cer/ceren.jpg'),
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/images/cer/ceren.jpg'),
                  class: "img-fluid img-thumbnail img-hover"
                }, null, 8, _hoisted_29)
              ], 8, _hoisted_28)
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("a", {
                href: require('@/assets/images/cer/certh.jpg'),
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/images/cer/certh.jpg'),
                  class: "img-fluid img-thumbnail img-hover"
                }, null, 8, _hoisted_33)
              ], 8, _hoisted_32)
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("a", {
                href: require('@/assets/images/cer/ceritpe.jpg'),
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/images/cer/ceritpe.jpg'),
                  class: "img-fluid img-thumbnail img-hover"
                }, null, 8, _hoisted_37)
              ], 8, _hoisted_36),
              _createElementVNode("a", {
                href: require('@/assets/images/cer/cereng.jpg'),
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/images/cer/cereng.jpg'),
                  class: "img-fluid img-thumbnail img-hover"
                }, null, 8, _hoisted_39)
              ], 8, _hoisted_38)
            ])
          ])
        ]),
        _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"col-md-12 text-center my-4\" data-v-1b6af368><hr class=\"border-2 border-white opacity-50\" data-v-1b6af368></div><div class=\"row\" id=\"other_cer_title\" data-v-1b6af368><div class=\"col-md-12 text-center text-white mb-3\" data-v-1b6af368><h3 class=\"fw-semibold\" data-v-1b6af368>Other Certificates</h3></div></div>", 2)),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("a", {
                href: require('@/assets/images/cer/udemy_git.jpg'),
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/images/cer/udemy_git.jpg'),
                  class: "img-fluid img-thumbnail img-hover"
                }, null, 8, _hoisted_44)
              ], 8, _hoisted_43)
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("a", {
                href: require('@/assets/images/cer/aws_page.jpg'),
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/images/cer/aws_page.jpg'),
                  class: "img-fluid img-thumbnail img-hover"
                }, null, 8, _hoisted_48)
              ], 8, _hoisted_47)
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("a", {
                href: require('@/assets/images/cer/Python_learn.jpg'),
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/images/cer/Python_learn.jpg'),
                  class: "img-fluid img-thumbnail img-hover"
                }, null, 8, _hoisted_52)
              ], 8, _hoisted_51)
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("a", {
                href: require('@/assets/images/cer/mern_learn.jpg'),
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/images/cer/mern_learn.jpg'),
                  class: "img-fluid img-thumbnail img-hover"
                }, null, 8, _hoisted_56)
              ], 8, _hoisted_55)
            ])
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("a", {
                href: require('@/assets/images/cer/go_maximillion.jpg'),
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/images/cer/go_maximillion.jpg'),
                  class: "img-fluid img-thumbnail img-hover"
                }, null, 8, _hoisted_60)
              ], 8, _hoisted_59)
            ])
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("a", {
                href: require('@/assets/images/cer/udamy_nodejs.jpg'),
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  src: require('@/assets/images/cer/udamy_nodejs.jpg'),
                  class: "img-fluid img-thumbnail img-hover"
                }, null, 8, _hoisted_64)
              ], 8, _hoisted_63)
            ])
          ])
        ])
      ])
    ])
  ]))
}